<template>
    <div :class="{'active-table': showTable}">
        <div class="table-state" :class="{'active': showTable}" @click="showTableAction(item.id)">
            <h3> {{ item.date }}</h3>
            <div class="plus" v-if="!showTable">
                <img class="plus"
                     src="../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable">
                <img src="../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <div class="search-table" v-show="showTable">
            <div class="search-input">
                <span>Поиск: </span>
                <input type="text" @keyup="filterSchedule" v-model="search">
            </div>
            <table-default :tableId="item.id" :data="getData"/>
        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TableDefault from "./TableDefault";

export default {
    components: {
        TableDefault
    },
    props: ["item"],
    data() {
        return {
            showTable: false,
            search: '',
        }
    },
    computed: {
        ...mapGetters(["schedulesTable"]),
        // getMonday() {
        //     return this.mondays.filter(r => r.id === this.item.id)
        // },
        getData() {
            if (this.item && this.item.id && this.schedulesTable[this.item.id] !== undefined) {
                return this.schedulesTable[this.item.id];
            }
            return []
        }
    },
    methods: {
        ...mapActions(["fetchSchedulesTable"]),
        filterSchedule() {
            setTimeout(() => {
                this.fetchSchedulesTable({search: this.search, id: this.item.id})
            }, 500)
        },
        showTableAction() {
            this.showTable = !this.showTable;
            if (!(this.schedulesTable[this.item.id] && this.schedulesTable[this.item.id].length)) {
                this.fetchSchedulesTable({search: this.search, id: this.item.id});
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.active-table {
    min-width: 100%;
    width: fit-content;
}

.table-state {
    display: flex;
    padding: 10px 12px 10px 0;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    cursor: pointer;
    position: sticky;
    color: #666;
    top: 45px;
    border-bottom: 1px solid #E0E0E0;

    h3 {
        font-weight: normal !important;
    }

    &:hover {
        color: #006688;
    }

    &.active {
        background: #006688;
        padding: 10px 12px;
        color: #FFFFFF;
        border-bottom: none;
    }

    @media screen and (max-width: 510px) {
        font-size: 11px;
    }
    @media screen and (max-width: 768px) {
        top: 0;
    }
}

.minus {
    filter: brightness(3);
}


.search-table {

    .search-input {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 20px 0;

        span {
            font-size: 13px;
            margin-right: 10px;
            margin-top: 4px;
        }

        input {
            background-color: #fff;
            padding: 5px;
            border: 1px solid;
            color: #000;
        }
    }
}
</style>